<div nxLayout="grid">
  <div nxRow="">
    <div nxCol="12">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
